/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedQuantitySelect_viewer = {
    readonly isRingSizesOn: boolean | null;
    readonly " $refType": "PdpSharedQuantitySelect_viewer";
};
export type PdpSharedQuantitySelect_viewer$data = PdpSharedQuantitySelect_viewer;
export type PdpSharedQuantitySelect_viewer$key = {
    readonly " $data"?: PdpSharedQuantitySelect_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedQuantitySelect_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedQuantitySelect_viewer",
  "selections": [
    {
      "alias": "isRingSizesOn",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "ringSizes"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"ringSizes\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'e0133ecf455d2d49e14118e830f86d0e';
export default node;
